export type RuntimeConfig = Readonly<{
  authProvider: string;
  azureClientId?: string;
  azureTenantId?: string;
  azureRedirectUri?: string;
}>;

export const getRuntimeConfig = (): RuntimeConfig =>
  (
    globalThis as typeof globalThis & {
      __OKAHU_RUNTIME_CONFIG__?: RuntimeConfig;
    }
  ).__OKAHU_RUNTIME_CONFIG__ ?? { authProvider: 'auth0' };

/**
 * JSON for the inline <script> the layout emits. "<" is escaped so no configured value can close
 * the element early; in script raw-text state it is the only tokenizer trigger, so that is enough
 * here but would not be for an attribute or nested context.
 */
export const serializeRuntimeConfig = (config: RuntimeConfig): string =>
  JSON.stringify(config).replace(/</g, '\\u003c');
